module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/components/campaign-monitor/campaign-monitor.component.scss
// module id = ./src/app/modules/boxoffice-module/components/campaign-monitor/campaign-monitor.component.scss
// module chunks = 9